import {
    Wifi, Wind, Users, Instagram, Navigation, Thermometer,
    CreditCard, Music, Calendar, Heart, Coffee, Smile,
    Camera, Phone, Star,
} from 'lucide-react';

const FEATURE_ICONS = {
    wifi: Wifi,
    smokingRoom: Wind,
    meetingRoom: Users,
    instagram: Instagram,
    bike: Navigation,
    cool: Thermometer,
    creditCard: CreditCard,
    parking: Navigation,
    music: Music,
    calendar: Calendar,
    heart: Heart,
    coffee: Coffee,
    smile: Smile,
    camera: Camera,
    phone: Phone,
    clock: Calendar,
};

export const FEATURE_ICON_FALLBACK = Star;

export default FEATURE_ICONS;
